import SvgIcon from "@/components/common/SvgIcon";
import { Typography } from "@/components/kit";
import { useTranslation } from "react-i18next";

export default function ListItems({
  setOpenConfirmDialog,
  handleClose,
}: {
  setOpenConfirmDialog: (val: boolean) => void;
  handleClose: () => void;
}) {
  const { t } = useTranslation();

  return (
    <>
      {/* <div
        onClick={() => {
          navigate("/employee");
          handleClose();
        }}
        className={
          "flex h-[36px] px-4 rounded-lg hover:bg-gray-50 cursor-pointer items-center gap-2 py-2"
        }
      >
        <SvgIcon iconName="userId" className="w-4 h-4" fill="fill-gray-800" />
        <Typography variant="Body2-Regular">Switch to User portal</Typography>
        <div className="flex-1" />
        <SvgIcon iconName="shuffle" className="w-3 h-3" fill="fill-gray-800" />
      </div> */}
      {/* <div
        onClick={() => {
          openStatusPage("https://status.trio.so/");
          handleClose();
        }}
        className={
          "flex h-[36px] px-4 rounded-lg hover:bg-gray-50 cursor-pointer items-center py-2 gap-2"
        }
      >
        <SvgIcon iconName="heart" className="w-4 h-4" fill="fill-gray-800" />
        <Typography variant="Body2-Regular">Service Status</Typography>
        <div className="flex-1" />
        <SvgIcon
          iconName="squareTopDown"
          className="w-3 h-3"
          fill="fill-gray-800"
        />
      </div> */}
      {/* <div
        onClick={() => {
          openStatusPage("https://help.trio.so/en");
          handleClose();
        }}
        className={
          "flex h-[36px] px-4 rounded-lg hover:bg-gray-50 cursor-pointer items-center py-2 gap-2"
        }
      >
        <SvgIcon iconName="help" className="w-4 h-4" fill="fill-gray-800" />
        <Typography variant="Body2-Regular">Help center</Typography>
        <div className="flex-1" />
        <SvgIcon
          iconName="squareTopDown"
          className="w-3 h-3"
          fill="fill-gray-800"
        />
      </div>
      <div
        onClick={() => {
          openStatusPage(
            "https://help.trio.so/en/collections/10716199-knowledge-base",
          );
          handleClose();
        }}
        className={
          "flex h-[36px] px-4 rounded-lg hover:bg-gray-50 cursor-pointer items-center py-2 gap-2"
        }
      >
        <SvgIcon
          iconName="notebook-3"
          className="w-4 h-4"
          fill="fill-gray-800"
        />

        <Typography variant="Body2-Regular">Knowledge base</Typography>
        <div className="flex-1" />
        <SvgIcon
          iconName="squareTopDown"
          className="w-3 h-3"
          fill="fill-gray-800"
        />
      </div>
      <div
        onClick={() => {
          handleGoTo("user");
          handleClose();
        }}
        className={
          "flex h-[36px] px-4 rounded-lg hover:bg-gray-50 cursor-pointer items-center py-2 gap-2"
        }
      >
        <SvgIcon
          iconName="userCircle"
          className="w-4 h-4"
          fill="fill-gray-800"
        />
        <Typography variant="Body2-Regular" color={"text-gray-800"}>
          {t("account")}
        </Typography>
      </div> */}
      {/* <div className="h-[1px] w-full bg-gray-100" /> */}
      <div
        className={
          "flex h-[36px] px-2 rounded-lg hover:bg-gray-50 cursor-pointer items-center py-2 gap-2"
        }
        onClick={() => {
          setOpenConfirmDialog(true);
          handleClose();
        }}
      >
        <SvgIcon iconName="logout2" className="w-5 h-5" fill="fill-red-500" />
        <Typography color="text-red-500" variant="Body2-Regular">
          {t("signOut")}
        </Typography>
      </div>
    </>
  );
}
